import { useCallback, useMemo } from 'react';

const useAddressField = (form, index) => {
  const streetValue = useMemo(
    () => form.getFieldValue(`streetIds[${index}]`),
    [form, index]
  );

  const houseValue = useMemo(
    () => form.getFieldValue(`houseIds[${index}]`),
    [form, index]
  );

  const flatValue = useMemo(
    () => form.getFieldValue(`addressIds[${index}]`),
    [form, index]
  );

  const handleStreetChange = useCallback(
    (value) => {
      form.setFieldsValue({
        [`streetIds[${index}]`]: value,
        [`houseIds[${index}]`]: undefined,
        [`addressIds[${index}]`]: undefined,
      });
    },
    [form, index]
  );

  const handleHouseChange = useCallback(
    (value) => {
      form.setFieldsValue({
        [`houseIds[${index}]`]: value,
        [`addressIds[${index}]`]: undefined,
      });
    },
    [form, index]
  );

  return {
    streetValue,
    houseValue,
    flatValue,
    handleStreetChange,
    handleHouseChange,
  };
};

export default useAddressField;
